// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_hg-1";
export var quotedThread = "_hg-0";